const WAIT_SUBMIT = 0;
const SUBMIT_TO_PLATFORM = 100;
const CHECKING = 200;
const AUDITING = 201;

/**
 * @Message("已驳回")
 * */
const REJECTED = 202;
const PARAM_ERROR = 402;

/**
 * @Message("待签约")
 * */
const NEED_SIGN = 204;

/**
 * @Message("已冻结")
 * */
const FROZEN = 203;


/**
 * @Message("待账户验证")
 * */
const ACCOUNT_NEED_VERIFY = 205;


/**
 * @Message("已作废")
 * */
const CANCELED = 207;

const FINISHED = 206;


export {WAIT_SUBMIT, SUBMIT_TO_PLATFORM, AUDITING, ACCOUNT_NEED_VERIFY, CANCELED, NEED_SIGN, FROZEN, REJECTED,CHECKING, FINISHED, PARAM_ERROR}